const GEO_BLOCK_CACHE_KEY = 'sharesquare.geo-blocked'
const REGION_BLOCKED_PATH = '/region-blocked'

const readGeoBlockCache = () => {
  if (typeof sessionStorage === 'undefined') {
    return null
  }

  try {
    const cachedValue = sessionStorage.getItem(GEO_BLOCK_CACHE_KEY)

    if (cachedValue !== 'true' && cachedValue !== 'false') {
      return null
    }

    return cachedValue === 'true'
  } catch (error) {
    console.warn('Unable to read geo-block cache:', error)
    return null
  }
}

export default defineNuxtRouteMiddleware((to) => {
  if (!process.client) {
    return true
  }

  if (readGeoBlockCache() !== true && to.path === REGION_BLOCKED_PATH) {
    return navigateTo('/')
  }

  return true
})